export default __webpack_public_path__ + "static/media/nbi_clearance.8cf118b2.jpg";